module.exports = __webpack_public_path__ + "img/drive.1951c1f8.png";